import React from 'react';

const styles = {
    container: {
        textAlign: 'left',
        backgroundColor: 'white', // Fondo azul
        color: 'black', // Texto en blanco
        padding: '20px',
    },
    content: {
        maxWidth: '800px',
        margin: '0 auto',
    },
};


function PrivacyPolicy() {
    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <h1>Política de Privacidad de RaDi Languages</h1>
                <br />
                <h2>Introducción</h2>
                <p>
                    Bienvenido a RaDi Languages, una aplicación diseñada para enseñar el idioma alemán a través de ejercicios interactivos. En RaDi Languages, valoramos y respetamos tu privacidad y estamos comprometidos en proteger tus datos personales. Esta Política de Privacidad tiene como objetivo explicar cómo recopilamos, utilizamos y protegemos la información que obtengamos de los usuarios de nuestra aplicación.
                </p>
                <br />
                <h2>Información que Recopilamos</h2>
                <p>
                    Cuando utilizas la aplicación RaDi Languages, solicitamos y recopilamos la siguiente información:
                </p>
                <ul>
                    <li><strong>Correo Electrónico:</strong> Requerimos una dirección de correo electrónico y una contraseña para registrarte y gestionar tu cuenta en la aplicación. Esta información se utiliza únicamente para autenticar tu identidad y proporcionarte acceso a los contenidos y funciones de la aplicación.</li>
                    <li><strong>Contraseña:</strong> La contraseña que eliges para tu cuenta se almacena de forma segura y encriptada. Solo tú tienes acceso a esta información y es esencial para proteger tu cuenta y tus datos personales.</li>
                </ul>
                <br />
                <h2>Uso de la Información</h2>
                <p>
                    La información que recopilamos se utiliza exclusivamente para los siguientes fines:
                </p>
                <ul>
                    <li><strong>Acceso y Autenticación:</strong> Utilizamos tu dirección de correo electrónico y contraseña para verificar tu identidad y permitirte acceder a la aplicación.</li>
                    <li><strong>Comunicación:</strong> En ocasiones, podemos utilizar tu dirección de correo electrónico para enviarte comunicaciones relacionadas con el servicio, como actualizaciones de la aplicación o notificaciones importantes.</li>
                </ul>
                <br />
                <h2>Seguridad de Datos</h2>
                <p>
                    En RaDi Languages, nos tomamos en serio la seguridad de tus datos personales. Implementamos medidas de seguridad técnicas y organizativas adecuadas para proteger tu información contra el acceso no autorizado, la divulgación, la alteración o la destrucción. Utilizamos métodos de encriptación y seguimos las mejores prácticas de seguridad de la industria.
                </p>
                <br />
                <h2>No Compartimos Tus Datos</h2>
                <p>
                    Queremos que sepas que nunca compartiremos, venderemos ni divulgaremos tu información personal a terceros sin tu consentimiento expreso. Tus datos son confidenciales y se utilizan únicamente para proporcionarte el servicio de aprendizaje de idiomas que ofrece RaDi Languages.
                </p>
                <br />
                <h2>Cambios en la Política de Privacidad</h2>
                <p>
                    Podemos actualizar ocasionalmente esta Política de Privacidad para reflejar cambios en nuestras prácticas de recopilación y uso de datos. Te recomendamos revisar esta política periódicamente para estar informado sobre cómo protegemos tus datos.
                </p>
                <br />
                <h2>Contacto</h2>
                <p>
                    Si tienes preguntas, inquietudes o comentarios sobre esta Política de Privacidad o sobre la manera en que manejamos tus datos personales, no dudes en contactarnos a través de la dirección de correo electrónico <a href="mailto:radilanguages.2020@gmail.com">radilanguages.2020@gmail.com</a>
                </p>
                <br />
                <p>
                    Al utilizar la aplicación RaDi Languages, aceptas los términos y condiciones de esta Política de Privacidad.
                </p>
                <br />
                <p>
                    Gracias por confiar en RaDi Languages para tu aprendizaje de alemán. ¡Esperamos que disfrutes de la aplicación!
                </p>
                <br />
                <p>Atentamente, RaDi Languages</p>
            </div>
        </div>
    );
}

export default PrivacyPolicy;